import React from 'react';
import UserService from './../../../service/user';
import { FORM_FIELD, AbstractPrompt } from './../core/abstract';
import ValidateService from './../../../service/validate';
import mapStateToProps from './../../../store/map/auth-token';
import mapDispatchToProps from './../../../store/map/on-logout';
import { connect } from 'react-redux';

class _UserEmailPrompt extends AbstractPrompt
{
    constructor(parms)
    {
        super(parms, _UserEmailPrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.getDefaultState = this.getDefaultState.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.onServerError = this.onServerError.bind(this);
        this.getSubmitButtonUi = this.getSubmitButtonUi.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getPromptUi = this.getPromptUi.bind(this);
        this.onSendVerifyCode = this.onSendVerifyCode.bind(this);
        this.onSendVerifyCodeResponse = this.onSendVerifyCodeResponse.bind(this);
        this.onServerResponse = this.onServerResponse.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
    }

    static getValidators()
    {
        return {
            nextEmail: {
                isValid: ValidateService.email
            },
            verifyCode: {
                isValid: ValidateService.valueRequired
            }
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            nextEmail: {
                name: 'New Email',
                error: 'Specify your new primary email address',
                value: '',
                visible: true,
                valid: false,
                touched: false,
                type: FORM_FIELD.TEXT,
            },
            verifyCode: {
                name: 'Verify Code',
                error: 'Specify the verify code you received at your current primary email address',
                value: '',
                visible: true,
                valid: false,
                touched: false,
                type: FORM_FIELD.TEXT,
            },
        };
    }

    getDefaultState(store)
    {
        const baseState = super.getDefaultState(store);
        const fields = this.getFieldsModel();
        return {
            ...baseState,
            ...fields,
            sendingVerifyCode: false,
            sentVerifyCode: false
        };
    }

    onSendToServer()
    {
        UserService.changeUserEmail({
            request: this.getServerRequest(),
            onResponse: this.onServerResponse,
            onError: this.onServerError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    onServerError(error)
    {
        const updateState = this.getBaseStateOnError(error);
        this.setState(updateState);
    }

    onServerResponse(response)
    {
        if(this.props.reloadParentData)
        {
            this.props.reloadParentData();
        }
    }

    getServerRequest()
    {
        return {
            nextEmail: this.state.nextEmail.value,
            verifyCode: this.state.verifyCode.value
        };
    }

    onSendVerifyCode()
    {
        let nextState = this.state;
        nextState.sendingVerifyCode = true;
        this.setState(nextState);
        UserService.sendEmailVerifyCode({
            onResponse: this.onSendVerifyCodeResponse,
            onError: this.onSendVerifyCodeResponse,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    onSendVerifyCodeResponse(response)
    {
        let nextState = this.state;
        nextState.sendingVerifyCode = false;
        nextState.sentVerifyCode = true;
        this.setState(nextState);
    }

    /* istanbul ignore next */
    getPromptUi()
    {
        return (
            <div>
                <h3>
                    Change your account email address
                </h3>
                <p>
                    Your current address is { this.props.currentEmail }
                </p>
                <div>
                    {
                        this.state.sendingVerifyCode ? 
                            <p>
                                Sending Verify Code...
                            </p> : 
                            (
                                this.state.sentVerifyCode ? 
                                    <p>
                                        A verification code has been sent to { this.props.currentEmail }
                                    </p> :
                                        <button 
                                            className="test-userEmailSendVerifyCodeBtn"
                                            onClick={event => { this.onSendVerifyCode() }}
                                        >
                                            Send Verify Code to { this.props.currentEmail }
                                        </button>
                            )
                    }
                </div>
                { super.getPromptUi() }
            </div>
        );
    }

}

const UserEmailPrompt = connect(mapStateToProps, mapDispatchToProps)(_UserEmailPrompt);
export default UserEmailPrompt;
